<div class="card">
  <header class="card-header">
    <p class="card-header-title is-size-4 has-background-white-ter">{{ config.title }}</p>
  </header>

  <div class="card-content">
    <div class="content">
      @if (!(config.optional ?? false)) {
        <div class="message is-warning">
          <div class="message-body">
            <span class="is-size-6"><strong>{{ 'fileUpload.mandatory.warning' | localize }}</strong> {{ 'fileUpload.mandatory.description' | localize }}</span>
          </div>
        </div>
      }
      <!-- File Upload Dropzone -->
      <article class="message is-dark mouse-pointer"
               [ngClass]="{ 'drag-over': isDragOver }"
               (dragover)="onDragOver($event)"
               (dragleave)="onDragLeave($event)"
               (drop)="onDrop($event)"
               (click)="fileInput.click()">
        <div class="message-body">
          <div class="dropzone-content">
            <mat-icon class="upload-icon">cloud_upload</mat-icon>
            <div class="dropzone-text">{{ config.dropzoneText }}</div>
            <div class="dropzone-subtext">
              {{ config.acceptedTypes.join(', ') }} ({{ config.maxSize }})
            </div>
          </div>
          <input
            [disabled]="uploading"
            #fileInput
            type="file"
            [multiple]="config.multiple"
            accept="{{getAcceptAttribute()}}"
            (change)="onFileSelect($event)"
            style="display: none">
        </div>
      </article>
      <!-- Selected Files List -->
      @if (selectedFiles.length > 0) {
        <h4 class="subtitle">{{ 'fileUpload.selectedFiles.title' | localize }}</h4>
        <div class="columns is-multiline">
          @for (file of selectedFiles; track file; let i = $index) {
            <div class="column is-full columns">
              <div class="column">
                <span class="icon"><i class="fas fa-file"></i></span>
                <span>{{ file.name }}</span>
                <span class="pl-3 pr-3"><code class="code">{{ formatFileSize(file.size) }}</code></span>
              </div>
              <div class="column is-narrow">
                <span class="icon has-text-danger" (click)="removeFile(i)"><i class="fas fa-trash"></i></span>
              </div>
            </div>
          }
        </div>
      }

      @if (uploading && selectedFiles.length > 0) {
        <div class="column is-full block">
          <p class="content">{{ 'fileUpload.uploading' | localize }}</p>
          <p class="content">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </p>
        </div>
      }
    </div>
    @if (errorMessages.length > 0) {
      <article class="message is-danger">
        <div class="message-header">
          <p>{{ 'fileUpload.error.title' | localize }}</p>
        </div>
        <div class="message-body">
          @for (errorMessage of errorMessages; track errorMessage) {
            <div class="content">
              {{ errorMessage }}
            </div>
          }
        </div>
      </article>
    }
  </div>

  <footer class="card-footer">
    @if (!uploading) {
      <div class="card-footer-item">
        <button class="button is-dark" [disabled]="uploading || uploaded || selectedFiles.length === 0"
                (click)="uploadFiles()">
          {{ config.actionName }}
        </button>
        @if (config.optional ?? false) {
          <span class="pl-3 pr-3"> </span>
          <button class="button is-dark" [disabled]="uploading || uploaded" (click)="skipUpload()">{{ 'fileUpload.skipUpload' | localize }}</button>
        }
        @if (uploaded) {
          <div class="message is-info">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ 'fileUpload.uploadCompleted' | localize }}
          </div>
        }
      </div>
    }
  </footer>
</div>
